import { useFormContext } from "react-hook-form";
import { Divider, Message } from "rsuite";
import { getMaxDate } from "../../utils/helper";
import CheckboxGroupInput from "../common/CheckboxGroupInput.tsx";
import CheckboxInput from "../common/CheckboxInput.tsx";
import NepaliDatePickerInput from "../common/NepaliDatePickerInput.tsx";
import SelectInput from "../common/SelectInput.tsx";
import SubmitButton from "../common/SubmitButton.tsx";
import { useEffect } from "react";
// import { usePostReviveAdultPolicy } from '../../hooks/lapsed-policy.ts';

interface Props {
  onSubmit: (data: any) => void;
  isPregnant?: boolean | string;
  hadMiscarriage?: boolean | string;
  hasChildren?: boolean | string;
  isNormalDelivery?: boolean | string;
  isProposer?: boolean;
  gender: string;
}

const ReviveAdultPolicyForm = ({
  onSubmit,
  isPregnant,
  hadMiscarriage,
  hasChildren,
  isNormalDelivery,
  isProposer = false,
  gender,
}: Props) => {
  //   const { mutateAsync } = usePostReviveAdultPolicy();
  const form = useFormContext();
  const hasValidationError = Object.keys(form.formState.errors).length > 0;
  const bmiError = isProposer
    ? form.formState.errors?.proposerBmi
    : form.formState.errors?.bmi;

  useEffect(() => {
    form.setValue("gender", gender);
  }, [gender]);

  return (
    <form
      className=""
      onSubmit={form.handleSubmit(onSubmit, async () => {
        console.error(form.formState.errors);
      })}
    >
      {!isProposer && (
        <Divider className="font-semibold md:text-lg text-sm">
          स्वास्थ्य सम्बन्धि उद्धोषणा
        </Divider>
      )}
      <div className=" space-y-2">
        <section className="flex gap-2 flex-col md:flex-row">
          <p>१. (क) तपाईको उचाइ कति छ </p>
          <SelectInput
            data={Array.from({ length: 8 }, (_, i) => i + 1).map((item) => {
              return { label: `${item} फिट`, value: item };
            })}
            name={isProposer ? "proposerHeight" : "heightFeet"}
            searchable={false}
            placeholder="Choose feet"
          />

          <SelectInput
            data={Array.from({ length: 11 }, (_, i) => i + 1).map((item) => {
              return { label: `${item} Inch`, value: item };
            })}
            name="heightInch"
            searchable={false}
            placeholder="Choose inches"
          />
        </section>
        <section>
          <SelectInput
            label="१. (ख) तपाईको वजन कति छ ? "
            data={Array.from({ length: 41 }, (_, i) => i + 30).map((item) => {
              return { label: `${item} kg`, value: item };
            })}
            name={isProposer ? "proposerWeight" : "weight"}
            searchable={false}
            placeholder="Choose weight"
          />
        </section>

        {/* <TextInput
          name={isProposer ? "proposerWeight" : "weight"}
          label="१.  (ख) तपाईको वजन कति छ ?"
          placeholder="..........."
        /> */}
      </div>

      <CheckboxGroupInput
        singleSelect
        options={[
          { label: "थियो", value: true },
          { label: "थिएन", value: false },
        ]}
        name={isProposer ? "proposerHadDisease" : "hasDisease"}
        label="२. तिन वर्ष यता तपाईलाई एक हप्ता अवधि सम्म रहने कुनै रोग लागेको थियो ?"
      />

      <CheckboxGroupInput
        singleSelect
        options={[
          { label: "थियो", value: true },
          { label: "थिएन", value: false },
        ]}
        name={isProposer ? "proposerHadSurgeryOrAccident" : "hasSurgery"}
        label="३. तिन वर्ष यता तपाईले कुनै शल्यक्रिया, दुर्घटना तथा सख्त घाईते, चोटपटक, कुनै अंग भंग भएको वा काटी फालेको समेत तथा रोग तथा चोट पटकको कारणले अस्पताल भर्ना भएको वा औषधी उपचार गरिएको थियो ?"
      />

      <CheckboxGroupInput
        singleSelect
        options={[
          { label: "छ", value: true },
          { label: "छैन", value: false },
        ]}
        name={isProposer ? "proposerHadCovid" : "hasCovid"}
        label="४. हाल तपाई कोभिड—१९ को संक्रमणबाट ग्रसित हुनुहुन्छ ?"
      />

      <CheckboxGroupInput
        singleSelect
        options={[
          { label: "छ", value: true },
          { label: "छैन", value: false },
        ]}
        name={isProposer ? "proposerIsHealthy" : "isHealthy"}
        label="५. तपाई अहिले पूर्ण स्वास्थ हुनुहुन्छ ?"
      />

      {gender == "FEMALE" && (
        <>
          <Divider className="font-semibold text-lg">
            {!isProposer
              ? "६.बीमित महिला भए मात्र भर्नुपर्ने विवरण :"
              : "प्रस्तावक महिला भए मात्र भर्नुपर्ने विवरण"}
          </Divider>

          <CheckboxGroupInput
            singleSelect
            options={[
              { label: "छ", value: true },
              { label: "छैन", value: false },
            ]}
            name="isPregnant"
            label="(क) के तपाई गर्भवती हुनुहुन्छ ?"
          />

          <div>
            <CheckboxGroupInput
              singleSelect
              options={[
                { label: "छ", value: true },
                { label: "छैन", value: false },
              ]}
              name="hasAbortion"
              label="(ख) गर्भपतन वा अन्य किसिमको असामान्य प्रसुति गर्नु भएको छ ?"
            />

            {hadMiscarriage && (
              <>
                <NepaliDatePickerInput
                  name="dateOfAbortion"
                  label="मिति"
                  maxDate={getMaxDate(3)}
                  className="mb-2"
                  placeholder="गर्भपतनको मिति छान्नुहोस्"
                />
                <Message type="warning">
                  <strong>नोट : </strong>यदि तपाईंले गर्भपतन वा अन्य किसिमको
                  असामान्य प्रसुति गर्नु भएको मिति ३ महिना भन्दा कम छ भने, तपाईं
                  यो फारम भर्न योग्य हुनुहुन्न ।
                </Message>
              </>
            )}

            <CheckboxGroupInput
              singleSelect
              options={[
                { label: "छ", value: true },
                { label: "छैन", value: false },
              ]}
              name="hasChildren"
              label={"(ग) के तपाईका छोराछोरी छन् ?"}
            />

            {hasChildren && (
              <div className="mb-2 space-y-2">
                <CheckboxGroupInput
                  singleSelect
                  options={[
                    { label: "शल्यक्रिया (C-section)", value: "c-section" },
                    { label: "सामान्य", value: "normal" },
                  ]}
                  name="deliveryType"
                  label="यदि छन् भने, अन्तिम प्रसूतिको तरिका:"
                />
                <NepaliDatePickerInput
                  name="dateOfPregnancy"
                  label="प्रसूति भएको मिति"
                  defaultDate=""
                  maxDate={isNormalDelivery ? getMaxDate(3) : getMaxDate(6)} //3 and 6 months
                />

                <Message type="warning">
                  <strong>नोट : </strong>यदि तपाईंको{" "}
                  {isNormalDelivery
                    ? "सामान्य प्रसूतिको मिति ३ महिना भन्दा कम छ भने"
                    : "शल्यक्रियाबाट प्रसूतिको मिति ६ महिना भन्दा कम छ भने"}{" "}
                  , तपाईं यो फारम भर्न योग्य हुनुहुन्न ।
                </Message>
              </div>
            )}

            <Divider />
          </div>
        </>
      )}

      {
        <CheckboxInput
          name="declaration"
          label="म सच्चा हृदयले उद्घोषण गर्दछु कि मैले यस फाराममा उल्लेखित सम्पूर्ण प्रश्नहरूको उत्तर सत्य, स्पष्ट तथा पूर्णरूपमा दिएको छु, र जीवन बीमा सम्बन्धी जोखिम मूल्याङ्कनका लागि आवश्यक कुनै पनि तथ्य वा परिस्थिति लुकाएको वा दबाएको छैन। प्रस्तुत स्वास्थ्य विवरण मेरो / बीमा चाहने व्यक्तिको जीवन बीमा पूर्नजागरणको आधार हुनेछ । यदि यस फाराममा उल्लेखित कुनै विवरण असत्य, अपूर्ण वा भ्रामक पाइएमा बीमालेखमा उल्लिखित सम्पूर्ण शर्त तथा प्रावधानहरू बमोजिम कम्पनीले आवश्यक निर्णय गर्न सक्नेछ भन्ने कुरा म पूर्णतः स्वीकार गर्दछु।"
          // label={
          //   !isProposer
          //     ? "म बिमित यो उद्द्योषण गर्दछु कि उपरोक्त प्रत्येक प्रश्नहरु राम्ररी बुझेर उत्तर दिएको छु । सबै उत्तरहरु सही तथा पूर्ण छन् र मेरो जीवन वीमा सम्बन्धि जोखिमको मुल्याङ्कन गर्न आवश्यक पर्ने कुनै पनि सूचना वा तथ्य जानाजान मैले लुकाएको छैन । यो प्रस्ताव सम्बन्धी सम्पूर्ण विवरण मेरो र आई.एम.ई लाइफ ईन्स्योरेन्स कम्पनी लिमिटेड विच भएको वीमा पूर्नजागरणको आधार हुनेछ र यदि यसमा कुनै पनि असत्य विवरण पाईएमा बीमालेखमा रहेको सम्पूर्ण शर्तहरु पूर्णरुपमा रद्द हुनेछ भनि स्वीकार गर्न मेरो मञ्जुर छ ।"
          //     : "म प्रस्तावक यो उद्द्योषण गर्दछु कि उपरोक्त प्रत्येक प्रश्नहरु राम्ररी बुझेर उत्तर दिएको छु । सबै उत्तरहरु सही तथा पूर्ण छन् र मेरो जीवन वीमा सम्बन्धि जोखिमको मुल्याङ्कन गर्न आवश्यक पर्ने कुनै पनि सूचना वा तथ्य जानाजान मैले लुकाएको छैन । यो प्रस्ताव सम्बन्धी सम्पूर्ण विवरण मेरो र आई.एम.ई लाइफ ईन्स्योरेन्स कम्पनी लिमिटेड विच भएको वीमा पूर्नजागरणको आधार हुनेछ र यदि यसमा कुनै पनि असत्य विवरण पाईएमा बीमालेखमा रहेको सम्पूर्ण शर्तहरु पूर्णरुपमा रद्द हुनेछ भनि स्वीकार गर्न मेरो मञ्जुर छ ।"
          // }
        />
      }

      {isPregnant === ("true" as unknown) && (
        <Message showIcon type="error">
          तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा
          ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।
        </Message>
      )}

      {hasValidationError && !isPregnant === ("true" as unknown) && (
        <Message showIcon type="error">
          कृपया सबै आवश्यक विवरणहरू सही रूपमा भर्नुहोस्।
        </Message>
      )}

      {bmiError && (
        <Message showIcon type="error">
          {String(bmiError.message)}
        </Message>
      )}
      <div className="flex justify-end">
        <SubmitButton className="btn-primary !text-white font-semibold rounded-lg shadow-md hover:bg-black duration-200 animate-blink">
          फारम बुझाउनुहोस्
        </SubmitButton>
      </div>
    </form>
  );
};

export default ReviveAdultPolicyForm;
